/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementGetTokenResponse } from './EventManagementGetTokenResponse';

export type EventManagementGetTokenResponseApiRespoonse = {
    data?: EventManagementGetTokenResponse;
    status?: EventManagementGetTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementGetTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

